import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RDDarkService } from './../dark.service';

@Component({
  selector: 'rd-small-card',
  template: `<div class="card">
  <div [class]="colorClass()">
    <span class="iconList" (click)="iconClick.emit()"><i [class]="iconClass()"></i></span>
    <div class="text" (click)="textClick.emit()">
      <ng-content select="div[role=title]"></ng-content>
      <ng-content select="div[role=type]"></ng-content>
    </div>
  </div>
</div>
`,
  styles: [`.card{width:100%;box-shadow:0 2px 5px 0 rgba(0,0,0,.16),0 2px 10px 0 rgba(0,0,0,.12);transition:all .1s ease-in-out}.card:hover{-webkit-transform:translateY(-6px);transform:translateY(-6px);box-shadow:0 8px 17px 0 rgba(0,0,0,.2),0 6px 20px 0 rgba(0,0,0,.19)}.cardList{font-size:20px;padding:6px;cursor:pointer;position:relative;box-sizing:border-box;--main-color:#ba9e5a;--background-color:#f1f1f1;--text-color:black}.cardList .iconList{position:absolute;top:0;right:-1px;min-width:40px;text-align:center;height:calc(100% + 1px)}.cardList .iconList>*{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.cardList .text{font-size:18px;width:calc(100% - 40px)}.cardList .text div:nth-child(2){font-size:14px;padding-left:6px}.objectCard{background-color:var(--background-color);color:var(--text-color);border:1px solid;border-color:var(--main-color);-o-border-image:var(--main-color) 1;border-image:var(--main-color) 1;transition:all .3s linear}.objectCard .iconList{background:var(--main-color);color:#fff}.objectCard.fullCard{background-color:var(--main-color);color:#fff}.objectCard.greenCard{--main-color:#72ba5a}.objectCard.blueCard{--main-color:#5a5aba}.objectCard.gradient-blueCard{--main-color:linear-gradient(45deg, #5aa2ba, #5a5aba)}.objectCard.blue-lightCard{--main-color:#5aa2ba}.objectCard.redCard{--main-color:#ba5a5a}.objectCard.purpleCard{--main-color:#a25aba}.objectCard.orangeCard{--main-color:#ba8a5a}.objectCard.rdDark{--background-color:transparent;--text-color:white}`]
})
export class RDSmallCardComponent implements OnInit {


  @Input() color = 'gold';
  @Input() icon = 'fa-times';
  @Input() background = 'full';

  @Output() textClick: EventEmitter<any> = new EventEmitter();
  @Output() iconClick: EventEmitter<any> = new EventEmitter();

  private dark = false;

  constructor(private darkService: RDDarkService) { }

  ngOnInit() {
    this.darkService.getDarkElement().subscribe(() => {
      this.dark = this.darkService.isDark();
    });
    this.dark = this.darkService.isDark();
  }

  colorClass() {
    return 'objectCard cardList ' + this.color + 'Card ' + this.background + 'Card' + (this.dark ? ' rdDark' : '');
  }

  iconClass() {
    return 'fas ' + this.icon;
  }

}
